export const APPLICATION_ORDER_TYPES = {
	1: "success",
	2: "pending",
	3: "info",
	4: "dark",
	5: "warning",
};

export const getApplicationOrderTypeVariant = (typeId) => {
	return APPLICATION_ORDER_TYPES[typeId] || "neutral";
};
